import { render, staticRenderFns } from "./ProductSalesPageSignUpBanner.vue?vue&type=template&id=224ec787&scoped=true&"
import script from "./ProductSalesPageSignUpBanner.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageSignUpBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ec787",
  null
  
)

export default component.exports